export function getFundingAmount(voucher, includeInfrastructure) {
  if (includeInfrastructure) {
    return Number(voucher?.fundingAmountWithInfrastructure ?? voucher?.fundingAmount ?? 0)
  }
  return Number(voucher?.fundingAmount ?? 0)
}
